import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Modal, Tab, Tabs, Stack, Button, Form, Accordion } from 'react-bootstrap';
import { faPlus, faFileAlt, faXmark, faPencil, faPaperclip, faCalendarDays, faCircleXmark, faPrint, faTrash, faCircleCheck, faChevronDown, faGear, faCog, faTimes } from '@fortawesome/free-solid-svg-icons';
import edit from "../../../../assets/images/edit.png";
import view from "../../../../assets/images/view.png";
import Arcv from "../../../../assets/images/archive.svg";
import Activ from "../../../../assets/images/active.svg";
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import Select from 'react-select';
import MessageBox from '../../../../Components/common/MessageBox';
import Docmnt from '../../../../assets/images/google-docs.png';
import { toast } from 'react-toastify';
import * as mammoth from 'mammoth';
import ConfModal from '../../../../Components/common/ConfModal.js';
import CreateDoc from './CreateDoc.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const DocManagement = ({ propdata }) => {
    const [disLoading, setDisLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(false);
    const [filterApplied, setFilterApplied] = useState(false);
    const [gridSelect, setGridSelect] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [tabCounts, setTabCounts] = useState({});
    const [showReadersModal, setShowReadersModal] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [innerData, setInnerData] = useState([]);
    const [awbList, setAwbList] = useState([]);
    const [gridData, setGridData] = useState([]);

    const gridRef = useRef(null);


    const [createModal, setCreateModal] = useState(false);
    const [createPos, setCreatePos] = useState('');
    const initFdata = {
        // publish_for: 'departments',
        is_publish: 0,
        // docName: '',
        version: '',
        department_id: [],
        template_id: '',
    }
    const [formData, setFormData] = useState(initFdata);
    const [imageOptions, setImageOptions] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [templateData, setTemplateData] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [readSignType, setReadSignType] = useState([]);

    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});

    const fetchAwb = async () => {
        try {
            const res = await withRFSToken.post("service-recovery/all-awb-number?tab=document")
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.master_airway_bill,
                        value: item.documentable_id,
                        documentable_type: item.documentable_type
                    })) : []
                    setAwbList(transformData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchReadSign = async () => {
        try {
            const res = await withRFSToken.post('get-meta-list', { type_id: 21 })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setReadSignType(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;

    const fetchImage = async () => {
        try {
            const res = await withRFSToken.get("/file-management/list")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const data = res.data.Rows;

                        const transformData = data?.map(item => ({
                            label: item.file_name,
                            value: item.id,
                            imageUrl: `${item.file_path}`
                        })) || [];

                        setImageOptions(transformData);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchdeparrtment = async () => {
        try {
            const res = await withRFSToken.get("/organisation-department/dropdown")
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;

                        const transformData = innerData ? innerData.map((item) => ({
                            label: item.label,
                            value: item.value
                        })) : []
                        setDepartmentList(transformData)
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetctemplatehData = async () => {
        try {
            const res = await withRFSToken.get('template/dropdown?tab=document')
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                // const transformData = innerData ? innerData.map((item) => ({
                //   label: item.label,
                //   value: item.value
                // })) : []
                setTemplateData(innerData)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ active: {} });

        fetchImage();
        fetchdeparrtment();
        fetctemplatehData();
        fetchAwb();
        fetchReadSign();
        // localStorage.removeItem('RS')
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (gridRef?.current) {
            // var token = "Bearer " + localStorage.ASR;
            jqxCookieCall();
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'version', type: 'string' },
                    { name: 'access', type: 'string' },
                    { name: 'docType', type: 'string' },
                    { name: 'updated_at', type: 'string' },
                    { name: 'updated_by', type: 'string' },
                    { name: 'created_by', type: 'string' },
                    { name: 'tracking', type: 'string' },
                    { name: 'title', type: 'string' },
                    { name: 'access', type: 'string' },
                    { name: 'published_by', type: 'string' },
                    { name: 'tracking', type: 'string' },
                    { name: 'document_title', type: 'string' },
                    { name: 'is_signed', type: 'string' },
                    { name: 'reminder', type: 'string' },
                    { name: 'readers', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'ref_no', type: 'string' },
                    { name: 'created_at', type: 'string' },
                    { name: 'updated_by', type: 'string' },
                    { name: 'last_edited_by', type: 'string' },
                    { name: 'organisation', type: 'string' },
                    { name: 'trucking_id', type: 'string' },
                    { name: 'master_airway_bill', type: 'string' },
                    { name: 'documentable_id', type: 'string' },
                ],
                id: `-`,
                url: `${process.env.REACT_APP_RFS_URL}document/list?tab=Active&documentable_type=service_recovery&documentable_id=${propdata.service_recovery_id}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setTabCounts(data.tabCounts);
                    // setTabCounts(prevCounts => ({
                    //   ...prevCounts,
                    //   [activeTab]: data.TotalRows || 0
                    // }));
                    if (!data?.Rows || data.Rows.length === 0) {
                        columns[0].cellsrenderer = () => "";
                    } else {
                        columns[0].cellsrenderer = actionRenderer();
                    }
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);


            const columns = [
                { text: 'Actions', cellsrenderer: actionRenderer(), width: '4%', filterable: false },
                { text: 'Document Name', datafield: 'name', width: '15%' },
                { text: 'Ref No.', datafield: 'ref_no', width: '10%' },
                // { text: 'Version', datafield: 'version', width: '10%' },
                { text: 'Created', datafield: 'created_at', width: '10%' },
                { text: 'Last Updated', datafield: 'updated_at', width: '10%' },
                { text: 'Last edited by', datafield: 'updated_by', width: '10%' },
                // { text: 'Organisation', datafield: 'organisation', width: '10%' },
                // { text: 'Access', datafield: 'access', width: '5%' },
                // {
                //     text: 'Record Id', datafield: 'master_airway_bill', width: '10%', cellclassname: 'rec_details',
                //     cellsrenderer: function (row, columnfield, value) {
                //         return '<div class="grid_actions" style="text-decoration:underline; cursor:pointer">' + value + '</div>';
                //     }
                // },
                // { text: 'Access', datafield: 'access', width: '10%' },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: '', // checkbox
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                }
            };

            window.$(gridRef.current).jqxGrid(gridOptions);

            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    } setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });

            window.$(gridRef.current).on('click', '.rec_details', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    // console.log('rowData', rowData); 
                    if (rowData?.documentable_id != null) {
                        localStorage.removeItem('RecoveryEdit');
                        console.log('Row Data:', rowData);
                        localStorage.setItem('RecoveryEdit', JSON.stringify({ service_recovery_id: rowData.documentable_id }));
                        const fnPageUrl = '/OverviewDetails';
                        window.location.href = fnPageUrl;
                    } else {
                        toast.error(' No document ID found for this row');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);

            });

            window.$(gridRef.current).off('click', '.row_edit');
            window.$(gridRef.current).off('click', '.row_view');

            // Handle edit (only Active tab)
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Edit Row Data:', rowData);
                        loadDetails(rowData)
                        // setFormData({
                        //   ...rowData,
                        //   department_id: rowData.department_id ? rowData.department_id.split(',').map(id => parseInt(id)) : []
                        // });
                        // setCreateModal(true); // open edit modal
                    }
                }
            });

            // Handle view (all other tabs)
            window.$(gridRef.current).on('click', '.row_view', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;

                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log("View Row Data:", rowData);
                        const data = {
                            id: rowData.id,
                        }
                        localStorage.setItem('RS', JSON.stringify(data))
                        window.location.href = '/ReadSign';
                        // setFormData(rowData);
                        // loadDetails(rowData);
                        // createRow(rowData);

                        //setViewModal(true); // open read-only modal
                    }
                }
            });
        }
    }, [gridData]);


    const loadDetails = async (id) => {
        // console.log("id for details==>", id.id);

        try {
            const res = await withRFSToken.post("/document/details", { "id": id.id });
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                setFormData(innerData);
                handleDoccreate('E');
            }
            // setInnerData(res.data.response_data);
            // setViewModal(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const createRow = async (id) => {
        try {
            const res = await withRFSToken.post("/document/create-row", { "id": id.id });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // -------------------- HELPERS ---------------------
    const actionRenderer = (tab) => {
        if (tab === "Active") {
            return () => '<div class="grid_actions"><img src="' + edit + '" class="row_edit" title="Edit"/></div>';
        } else {
            return () => '<div class="grid_actions"><img src="' + edit + '" class="row_edit" title="Edit"/></div>';
            // return () => '<div class="grid_actions"><img src="' + view + '" class="row_view" title="View"/></div>';
        }
    };

    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');

    };
    // const handleChange = (field, value) => {
    //   if (field === 'is_publish' && value == '1') {
    //     setFormData(prev => ({
    //       ...prev,
    //       [field]: value,
    //       requires_login: '1',
    //       announcement: '0',
    //       read_and_sign: '1',
    //     }));
    //   } else if (field === 'publish_for') {
    //     if (value === 'private') {
    //       setFormData(prev => ({
    //         ...prev,
    //         [field]: value,
    //         read_and_sign: '0',
    //         read_sign_type: null
    //       }));
    //     } else {
    //       setFormData(prev => ({
    //         ...prev,
    //         [field]: value,
    //         read_and_sign: '1',
    //         read_sign_type: null
    //       }));
    //     }

    //   } else if (field === 'announcement' && value === '0') {
    //     setFormData(prev => ({
    //       ...prev,
    //       [field]: value,
    //       read_and_sign: '1',
    //       read_sign_type: null
    //     }));
    //   } else {
    //     setFormData(prev => ({
    //       ...prev,
    //       [field]: value
    //     }));
    //   }


    // }
    const handleChange = (field, value) => {
        console.log('value', value);

        setFormData(prev => {
            let updated = { ...prev, [field]: value };

            const removeFields = (fields) => {
                fields.forEach(f => delete updated[f]);
            };

            if (field === "is_publish") {
                if (value === 1) {
                    updated = {
                        ...updated,
                        requires_login: 1,
                        announcement: 0,
                        read_and_sign: 1,
                        publish_for: 'departments',
                    };
                } else if (value === 0) {
                    removeFields(["requires_login", "announcement", "read_and_sign", "read_sign_type", "publish_for", "department", "publishLink"]);
                }
            }

            if (field === "announcement") {
                if (value === 1) {
                    removeFields(["read_and_sign", "read_sign_type"]);
                    updated.announcement_days = 30;
                } else if (value === 0) {
                    updated.read_and_sign = 1;
                    updated.read_sign_type = null;
                }
            }

            if (field === "publish_for") {
                if (value === "private") {
                    removeFields(["read_sign_type"]);
                    updated.read_and_sign = 0;
                } else {
                    updated.read_and_sign = 1;
                    updated.read_sign_type = null;
                }
            }

            return updated;
        });
    };




    //-------------------- for image section-------->

    const [files, setFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const fileInputRef = useRef(null);
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleImageSelect = (key, data) => {
        // console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });

                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    //<---------------------end---------------------------->

    //  npm install mammoth pdfjs-dist

    //<------------------------convert file dox and pdf--------------------->
    const [selectedFile, setSelectedFile] = useState(null);
    const [extractedText, setExtractedText] = useState('');

    const [error, setError] = useState('');
    const [copied, setCopied] = useState(false);
    const fileInputRef1 = useRef(null);

    const handleBrowseFiles1 = (e) => {
        e.preventDefault();
        fileInputRef1.current.click();
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];

        const isValidFile = (
            file?.type === 'application/pdf' ||
            file?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            file?.type === 'application/msword' ||
            file?.name.toLowerCase().endsWith('.doc') ||
            file?.name.toLowerCase().endsWith('.docx') || ''
        );

        if (file && isValidFile) {
            setSelectedFile(file);
            setError('');
            setExtractedText('');
        } else {
            setError('Please select a valid PDF, DOC, or DOCX file');
            setSelectedFile(null);
        }
    };

    const convertDocumentToText = async () => {
        if (!selectedFile) return;

        // setIsLoading(true);
        setError('');
        setExtractedText('');

        try {
            const fileExtension = selectedFile.name.toLowerCase().split('.').pop();
            let extractedContent = '';

            if (fileExtension === 'pdf') {
                extractedContent = await convertPdfToHtml();
            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                extractedContent = await convertWordToHtml();
            }

            if (extractedContent.trim()) {
                setExtractedText(extractedContent.trim());
                setFormData(prev => ({
                    ...prev,
                    content: extractedContent.trim()
                }));
            } else {
                setError('No content found in the document. The file might contain only images or be password protected.');
            }

        } catch (err) {
            setError(`Error converting document: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    const convertPdfToHtml = async () => {
        let pdfjsLib = window.pdfjsLib;

        if (!pdfjsLib) {
            await new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
                script.onload = () => {
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
                    resolve();
                };
                script.onerror = reject;
                document.head.appendChild(script);
            });
            pdfjsLib = window.pdfjsLib;
        }

        const arrayBuffer = await selectedFile.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

        let html = "<div class='pdf-html'>";
        let buffer = ""; // to collect paragraph text

        for (let p = 1; p <= pdf.numPages; p++) {
            const page = await pdf.getPage(p);
            const content = await page.getTextContent();

            html += `<div class='page' data-page='${p}'>`;

            let lastY = null; // track line changes

            content.items.forEach((item, i) => {
                const text = item.str.trim();
                if (!text) return;

                const fontSize = Math.round(item.height); // Heading detection
                const y = Math.floor(item.transform[5]); // Y axis for line grouping

                const isBullet = /^(\•|\-|\–|\*)/.test(text);

                // Detect new line
                if (lastY !== null && Math.abs(lastY - y) > 6) {
                    if (buffer.trim()) {
                        html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                    }
                }

                // HEADINGS (PDF usually > 14px)
                if (fontSize >= 14 && !isBullet && text.length <= 60) {
                    if (buffer.trim()) {
                        html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                    }
                    html += `<h3>${text}</h3>`;
                }

                // BULLET LIST
                else if (isBullet) {
                    if (!html.endsWith("<ul>")) {
                        if (buffer.trim()) html += `<p>${buffer.trim()}</p>`;
                        buffer = "";
                        html += "<ul>";
                    }
                    html += `<li>${text.replace(/^(\•|\-|\–|\*)/, "").trim()}</li>`;
                }

                // NORMAL PARAGRAPH CONTENT
                else {
                    buffer += text + " ";
                }

                lastY = y;
            });

            // Close leftover text in buffer
            if (buffer.trim()) {
                html += `<p>${buffer.trim()}</p>`;
                buffer = "";
            }

            // Close <ul> if still open
            if (html.endsWith("</li>")) {
                html += "</ul>";
            }

            html += "</div>"; // page end
        }

        html += "</div>";
        return html;
    };


    // const convertPdfToHtml = async (file) => {
    //   const fileReader = new FileReader();

    //   return new Promise((resolve, reject) => {
    //     fileReader.onload = async () => {
    //       const data = new Uint8Array(fileReader.result);

    //       try {
    //         const pdf = await pdfjsLib.getDocument({ data }).promise;
    //         let finalHTML = `<div class="pdf-html">`;

    //         for (let i = 1; i <= pdf.numPages; i++) {
    //           const page = await pdf.getPage(i);
    //           const text = await page.getTextContent();

    //           finalHTML += mapPdfContentToHtml(text.items);
    //         }

    //         finalHTML += `</div>`;
    //         resolve(finalHTML);
    //       } catch (err) {
    //         reject(err);
    //       }
    //     };

    //     fileReader.readAsArrayBuffer(file);
    //   });
    // };
    const mapPdfContentToHtml = (items) => {
        let html = "";
        let buffer = "";

        items.forEach((item) => {
            const text = item.str.trim();
            if (!text) return;

            const fontSize = item.transform[0]; // used to detect headings

            // Heading
            if (fontSize > 12) {
                html += `<h3>${text}</h3>`;
            }
            // Bulleted list
            else if (/^[•|\-]/.test(text)) {
                buffer += `<li>${text.replace(/^•|\-/, "").trim()}</li>`;
            }
            // Normal paragraph
            else {
                buffer += `${text} `;
            }
        });

        // Wrap bullets or paragraph
        if (buffer.includes("<li>")) buffer = `<ul>${buffer}</ul>`;
        else buffer = `<p>${buffer}</p>`;

        html += buffer;
        return html;
    };


    const convertWordToHtml = async () => {
        const arrayBuffer = await selectedFile.arrayBuffer();

        const result = await mammoth.convertToHtml({ arrayBuffer });
        console.log('Conversion result:', result);

        if (result.messages && result.messages.length > 0) {
            console.warn('Conversion warnings:', result.messages);
        }

        return `<div class="word-content">${result.value}</div>`;
    };

    const addDocumentStyles = () => {
        const styles = `
    <style>
      .pdf-content, .word-content {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: #333;
      }
      .page {
        margin-bottom: 30px;
        padding: 20px;
        border-bottom: 1px solid #eee;
      }
      .page h3 {
        color: #666;
        font-size: 18px;
        margin-bottom: 15px;
        border-bottom: 2px solid #007bff;
        padding-bottom: 5px;
      }
      .page h4 {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        margin: 15px 0 10px 0;
      }
      .page p {
        margin-bottom: 10px;
        text-align: justify;
      }
      .word-content h1, .word-content h2, .word-content h3 {
        color: #333;
        margin-top: 20px;
        margin-bottom: 10px;
      }
      .word-content p {
        margin-bottom: 10px;
        text-align: justify;
      }
      .word-content ul, .word-content ol {
        margin: 10px 0;
        padding-left: 30px;
      }
      .word-content table {
        border-collapse: collapse;
        width: 100%;
        margin: 15px 0;
      }
      .word-content th, .word-content td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }
      .word-content th {
        background-color: #f2f2f2;
        font-weight: bold;
      }
    </style>
  `;
        return styles;
    };

    // Update the convert button click handler to include styles:
    const handleConvertWithStyles = async () => {
        await convertDocumentToText();

        // If you want to include CSS styles in the HTML output:
        if (formData.content) {
            const styledContent = addDocumentStyles() + formData.content;
            setFormData(prev => ({
                ...prev,
                content: styledContent
            }));
        }
    };


    const resetConverter = () => {
        setSelectedFile(null);
        setExtractedText('');
        setError('');
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    //<------------------------end------------------------------------------>

    const handleDoccreate = (pos) => {
        setCreateModal(true);
        setCreatePos(pos);
        if (pos === 'N') {
            setFormData(initFdata)
        }
        setSelectedFile(null);
    }

    const saveDoc = async () => {
        //setCreateModal(false);
        // console.log("formData==>", formData);
        setDisLoading(true);
        try {
            const res = await withRFSToken.post("document/add-update", formData);
            if (res.data.response_code == 200) {
                setCreateModal(false)

                window.$(gridRef.current).jqxGrid('updatebounddata');
                toast.success(res.data.response_msg);

            } else {

                toast.error(res.data.response_msg);
            }
            setDisLoading(false);
        } catch (error) {
            console.error('Error sending request:', error);
            setDisLoading(false);
        }
    }

    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };

        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img src={imageUrl} alt={label} style={{ width: 30, height: 30, objectFit: 'cover', borderRadius: 4, marginRight: 10 }} />
                <span>{displayLabel}</span>
            </div>
        );
    };

    const handlePrint = () => {
        window.print();
    };

    const handleCheckboxChange = (e) => {
        if (e.target.checked) {
            // console.log("checked==>", e.target.checked);

            setShowConfirm(true);
        } else {

            setIsChecked(false);
        }
    };

    const handleConfirmYes = () => {
        setIsChecked(true);
        setShowConfirm(false);
    };

    const handleConfirmCancel = () => {
        setIsChecked(false);
        setShowConfirm(false);
    };
    const updateStatus = async () => {
        if (!isChecked) {
            toast.error("Please confirm that you have read and understood the document.");
            return;
        }
        // console.log("formData for sign==>", formData.id);
        return false;
        setDisLoading(true);
        try {
            const res = await withRFSToken.post("document/update-signed", { id: formData.id });
            if (res.data.response_code == 200) {
                setViewModal(false)
                window.$(gridRef.current).jqxGrid('updatebounddata');
                toast.success(res.data.response_msg);
            } else {
                toast.error(res.data.response_msg);
            }
            setDisLoading(false);
        }
        catch (error) {
            console.error('Error sending request:', error);
            setDisLoading(false);
        }
    }


    const confModalClose = () => setModalConf(false);
    const handleSave = () => {
        window.$(gridRef.current).jqxGrid('updatebounddata');
        setCreateModal(false)
    }

    return (
        <>
            {/* {console.log("formData==>", formData)}
      {console.log("ActiveTab==>", activeTab)} */}

            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    <button className="addtruck me-2" variant="primary" onClick={() => handleDoccreate('N')} >
                        <span> <FontAwesomeIcon icon={faPlus} /> Create Doc</span>
                    </button>
                </div>
                <div className='ulddown'>

                </div>
            </div>

            <div className="maindiv">
                <div className='trashdonload'>
                    {disLoading &&
                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                    }
                    {!isLoading && <>
                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                        <div ref={gridRef} className='bookinggrid' ></div>
                    </>
                    }
                </div>
            </div>
            {createModal &&
                <CreateDoc
                    details_doc={true}
                    sendData={createPos == 'E' ? formData : null}
                    onclose={() => setCreateModal(false)}
                    onSave={handleSave} createPos={createPos}
                    srId={propdata.service_recovery_id}
                />
            }


            <style>
                {`
      .document-modal h4 {
        font-size: 20px;
        font-weight: bold;
      }
      .document-modal .bg-light {
        background-color: #f8f9fa !important;
      }
      .document-modal .bg-dark {
        background-color: #1c1c1c !important;
        border-radius: 8px;
      }
    `}
            </style>
            <style>
                {`
          @media print {
            body * {
              visibility: hidden;
            }
            .modal-content, .modal-content * {
              visibility: visible;
            }
            .modal-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              box-shadow: none !important;
              border: none !important;
            }
          }
        `}
            </style>

            <Modal show={viewModal} onHide={() => setViewModal(false)} className="document-modal add_task_modal" centered size="lg">
                <Modal.Header closeButton>
                    <h5 className="mb-0">
                        <FontAwesomeIcon icon={faFileAlt} className="me-2 text-primary" />
                        {formData?.name || "View Document"}
                    </h5>
                    {/* Print Icon on right side */}
                    <div className="ms-auto">
                        <Button
                            variant="light"
                            size="sm"
                            onClick={handlePrint}
                            title="Print Document"
                        >
                            <FontAwesomeIcon icon={faPrint} />
                        </Button>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    {/* Document Title + ID */}
                    <div className="mb-3">
                        <h4 className="fw-bold">{formData?.name}</h4>
                        <p className="text-muted mb-1">
                            ID : <span className="fw-semibold">{formData?.docId}</span>
                        </p>
                        <hr />
                    </div>

                    {/* Content Preview */}
                    <div className="mb-4">
                        <div
                            className="p-3 border rounded bg-light"
                            style={{ maxHeight: 250, overflowY: "auto" }}
                        >
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: innerData?.content || "<i>No content available</i>",
                                }}
                            />
                        </div>
                    </div>

                    {/* Attached Documents */}
                    <div className="p-3 bg-light rounded mb-3">
                        <h6 className="fw-bold">Attached Documents</h6>
                        <p className="text-muted small">No attachments available</p>
                    </div>

                    {/* Read & Sign */}
                    <div className="d-flex justify-content-end align-items-center mb-3">
                        <input
                            type="checkbox"
                            id="readSign"
                            className="me-2"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        <label htmlFor="readSign" className="mb-0">
                            Read & Sign
                        </label>
                    </div>

                    {/* Footer Meta Info */}
                    <div className="bg-dark text-white p-3 rounded small">
                        <Row>
                            <Col md={6}>
                                <p className="mb-1">
                                    <strong>Ref.No:</strong> {innerData?.ref_no}
                                </p>
                                <p className="mb-1">
                                    <strong>Created by:</strong> {formData?.created_by}
                                </p>
                                <p className="mb-1">
                                    <strong>Last Edited by:</strong> {formData?.updated_by}
                                </p>
                            </Col>
                            <Col md={6}>
                                <p className="mb-1">
                                    <strong>Version:</strong> {formData?.version}
                                </p>
                                <p className="mb-1">
                                    <strong>Last Update:</strong> {formData?.updated_by}
                                </p>
                                <p className="mb-1">
                                    <strong>Published by:</strong> {formData?.updated_by}
                                </p>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setViewModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => updateStatus()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showConfirm} onHide={handleConfirmCancel} centered style={{ zIndex: 9999 }} >
                <Modal.Body className="text-center">
                    <p>Do you want to save this as signed?</p>
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <Button variant="primary" onClick={handleConfirmYes}>
                            Yes
                        </Button>
                        <Button variant="secondary" onClick={handleConfirmCancel}>
                            Cancel
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showReadersModal} onHide={() => setShowReadersModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Readers for Row ID: {selectedRowId}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Your content here */}
                </Modal.Body>
            </Modal>

        </>
    )
}

export default DocManagement;

